import { render, staticRenderFns } from "./ControlTask.vue?vue&type=template&id=009a36c1&scoped=true"
import script from "./ControlTask.vue?vue&type=script&lang=js"
export * from "./ControlTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a36c1",
  null
  
)

export default component.exports